"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getXsrfCookieName = void 0;
/* istanbul ignore file */
const configment_1 = __importDefault(require("@ten-x/configment"));
const constants_1 = require("./constants");
/**
 * Get the XSRF_COOKIE_NAME provided in the config or return the
 * default (XSRF-TOKEN) if no value is found. Used mainly to
 * separate CAMP cookies from TENX ones.
 *
 * Only this method lives here because we need it in the index.browser
 * so that it can be exposed and safely consumed in the browser.
 * We could think of grouping the other methods that live in the main
 * file and are related to cookies and have two cookie files
 */
function getXsrfCookieName() {
    return configment_1.default.get("XSRF_COOKIE_NAME", constants_1.DEFAULT_XSRF_COOKIE_NAME);
}
exports.getXsrfCookieName = getXsrfCookieName;
